export const saasRoutes = {
  default: 'saas_dashboard',
  builderLabs: 'saas-builder-labs',
  planUpdate: 'saas-plan-update',
  planCreate: 'saas-plan-create',
  education:'saas_education',
  fastTrack:'saas_fasttrack',
  paymentSetup: 'payment_setup'
}
